import { render, staticRenderFns } from "./Lessons-availability.vue?vue&type=template&id=637272d0&scoped=true&lang=html"
import script from "./Lessons-availability.vue?vue&type=script&lang=js"
export * from "./Lessons-availability.vue?vue&type=script&lang=js"
import style0 from "./Lessons-availability.vue?vue&type=style&index=0&id=637272d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637272d0",
  null
  
)

export default component.exports